import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=74964efd&scoped=true"
import script from "./MyHistory.vue?vue&type=script&lang=js"
export * from "./MyHistory.vue?vue&type=script&lang=js"
import style0 from "./MyHistory.vue?vue&type=style&index=0&id=74964efd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74964efd",
  null
  
)

export default component.exports